import { render } from "./Wb.vue?vue&type=template&id=f0ff6e68"
import script from "./Wb.vue?vue&type=script&lang=js"
export * from "./Wb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__